import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { LogoMark } from "./Logo";

const links = [
  { to: "/giai-phap", label: "Giải pháp" },
  { to: "/tinh-nang", label: "Tính năng" },
  { to: "/bang-gia", label: "Bảng giá" },
  { to: "/bao-mat", label: "Bảo mật" },
  { to: "/gioi-thieu", label: "Giới thiệu" },
];

export function Nav() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header className={`nav ${open ? "open" : ""}`}>
      <div className="container nav-inner">
        <Link to="/" className="brand">
          <span className="mark">
            <LogoMark />
          </span>
          Ghi Âm Pro
        </Link>

        <nav className="nav-links">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} className={({ isActive }) => (isActive ? "active" : "")}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="nav-cta">
          <Link to="/lien-he" className="btn btn-primary">
            Yêu cầu demo
          </Link>
        </div>

        <button
          className="nav-toggle"
          aria-label="Mở menu"
          onClick={() => setOpen((v) => !v)}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" stroke="#0c1330" strokeWidth="2" fill="none" strokeLinecap="round">
            {open ? <path d="M6 6l12 12M18 6 6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
          </svg>
        </button>
      </div>
    </header>
  );
}
